import Axios from 'axios'
import moment from 'moment-business-days'
const FileSaver = require('file-saver')

const MINUTES_TO_WAIT_IN_MILLISECONDS = 1.5 * 60 * 1000

export const searchClients = async (searchParams) => {
  const response = await Axios.post('/clientes/search', searchParams)
  return response.data
}

export const searchMyClients = async (searchParams) => {
  const response = await Axios.post('/clientes/mine', searchParams)
  return response.data
}

export const exportMyClientsRequest = async (searchParams) => {
  const config = {
    responseType: 'arraybuffer',
    timeout: MINUTES_TO_WAIT_IN_MILLISECONDS,
  }

  const response = await Axios.post('/clientes/exportMyClients', searchParams, config)
  if (response && response.data) {
    FileSaver.saveAs(new Blob([response.data]), `MisClientes-${moment().format('YYYYMMDD')}.xlsx`, {
      autoBOM: true,
    })
  }
}
